import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * The programmatic identifier of the storageCorrectContentLengthPolicy.
 */
export var storageCorrectContentLengthPolicyName = "StorageCorrectContentLengthPolicy";
/**
 * storageCorrectContentLengthPolicy to correctly set Content-Length header with request body length.
 */

export function storageCorrectContentLengthPolicy() {
  return {
    name: storageCorrectContentLengthPolicyName,
    sendRequest: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, next) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", next(request));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sendRequest(_x, _x2) {
        return _sendRequest.apply(this, arguments);
      }

      return sendRequest;
    }()
  };
}